import type { ColorCatalog, SizeCatalog, StyleCatalog } from '@/types/Catalogs';
import { axios } from './axiosClient';
import { validate } from '@/utils/errors/helpers';
import { getColorCatalogsSchema } from '@/types/schemas/catalogs/getColorCatalogs';
import { getStyleCatalogsSchema } from '@/types/schemas/catalogs/getStyleCatalogs';
import { getSizeCatalogsSchema } from '@/types/schemas/catalogs/getSizeCatalogs';

export async function getColorCatalogs(): Promise<ColorCatalog[]> {
  const response = await axios.get('v2/materials/catalogs/colors');
  return validate(getColorCatalogsSchema, response.data.data);
}
export async function getSizeCatalogs(): Promise<SizeCatalog[]> {
  const response = await axios.get('v2/materials/catalogs/sizes');

  return validate(getSizeCatalogsSchema, response.data.data);
}
export async function getStyleCatalogs(): Promise<StyleCatalog[]> {
  const response = await axios.get('v2/materials/catalogs/styles');

  return validate(getStyleCatalogsSchema, response.data.data);
}
